export function buildPlannerMapStatus(activePointsMap, currentWaypoints) {
  return {
    activePointsMap,
    currentWaypoints
  }
}

export function buildPlannerResetPointsState() {
  return {
    activePointsMap: false,
    currentWaypoints: '',
    waypoints: ''
  }
}

export function buildPlannerFocusState(directionField) {
  return {
    activeField: directionField,
    locations: []
  }
}

export function buildPlannerMapSelectionState(currentWaypoints, nextWaypoints) {
  if (currentWaypoints === nextWaypoints) {
    return {
      shouldReset: true,
      updates: {}
    }
  }

  return {
    shouldReset: false,
    updates: {
      currentWaypoints: nextWaypoints,
      activePointsMap: true
    }
  }
}

export function buildSearchDirectionOnMapUpdate(searchDirectionOnMap) {
  if (!searchDirectionOnMap) {
    return {}
  }

  const { input, direction, cordenate } = searchDirectionOnMap

  if (input !== 'origin' && input !== 'destination') {
    return {}
  }

  const { lat, lng } = cordenate
  const directionField = input === 'origin' ? 'originDirection' : 'destinationDirection'
  const coordinatesField = input === 'origin' ? 'originCoordinates' : 'destinationCoordinates'

  return {
    [directionField]: direction,
    [coordinatesField]: `${lat},${lng}`
  }
}
